import { createApp } from "vue";
import App from "./App.vue";
import router from './router'; // Router importieren
import store from './store';
import { createI18n } from "vue-i18n";
import de from "./locales/de.json";
import en from "./locales/en.json";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import './registerServiceWorker'
import heatmap from 'vue-heatmapjs';

import AddToHomescreen from '@owliehq/vue-addtohomescreen';
// Vue I18n initialisieren
const i18n = createI18n({
    locale: 'en', // Fallback-Sprache
    fallbackLocale: 'en',
    messages: { en, de },

});

// Gespeicherte Sprache aus localStorage prüfen
const savedLanguage = localStorage.getItem('languageSelection');
if (savedLanguage) {
    i18n.locale = savedLanguage;
    i18n.global.locale = savedLanguage;
}

const app = createApp(App);
app.use(store);
app.use(AddToHomescreen, {
    buttonColor: '#FFDA00',
    buttonTextColor: '#5c5750',
    title: 'Baseball5 web-app',
    iconPath: 'img/apple-icon-180.png',

});
app.use(i18n);
app.use(heatmap);
app.use(router); // Router hinzufügen
app.mount('#app');
